
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-cards/redemption-confirmation",
      function () {
        return require("private-next-pages/gift-cards/redemption-confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-cards/redemption-confirmation"])
      });
    }
  